import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import './constants/globalDefinitions';
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import Root from "./screens/Root";
import Loading from "./components/Loading";
import './i18n';
import * as Sentry from "@sentry/react";
import * as Tracking from "@sentry/tracing";
import SentryFallback from "./components/SentryFallback";

import 'datastake-daf/src/styles/_index.scss';
import './style/index.scss';

if (process.env.REACT_APP_SENTRY_ENV !== 'local') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    integrations: [new Tracking.Integrations.BrowserTracing()],
    tracesSampleRate: 0.2,
    environment: process.env.REACT_APP_SENTRY_ENV,
  });

  Sentry.setTag('server_name', 'frontend');
}

const root = createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={SentryFallback}>
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<Loading />}><Root /></Suspense>
      </BrowserRouter>
    </Provider>
  </Sentry.ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
console.disableYellowBox = true;
